var exports = {
  "iE": "xaee3c4fa--d5658c--wrapper",
  "o5": "xaee3c4fa--d5658c--content-wrapper",
  "su": "xaee3c4fa--d5658c--icon-wrapper",
  "Nf": "xaee3c4fa--d5658c--footnote-wrapper",
  "$U": "xaee3c4fa--d5658c--headnote",
};

module.exports = exports;
